import { render } from "./ModalDocumentDelete.vue?vue&type=template&id=33e58baa&scoped=true"
import script from "./ModalDocumentDelete.vue?vue&type=script&lang=js"
export * from "./ModalDocumentDelete.vue?vue&type=script&lang=js"

import "./ModalDocumentDelete.vue?vue&type=style&index=0&id=33e58baa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e58baa"]])

export default __exports__